import { Button } from '@material-ui/core'
import React, { useEffect } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

import BookingImg from '../../Assets/images/booking.png'

const AppointmentSuccess = () => {

    return (
        <>
            {/* <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet> */}
            <div className="gs_myaccount gs_order_success">
                <Container className="gs_customer_container">
                    <Row className="w-100 m-auto">
                        <Col>
                            <Image src={BookingImg} className='img-fluid' alt="Order Success"></Image>
                            <h1>THANK YOU</h1>
                            <p className="mt-1 d-inline-block" style={{fontSize:'20px'}}>Your Appointment Successfull.</p>

                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}
export default AppointmentSuccess;